import { z } from "zod"

export const pimDeliverySettlementIdSchema = z.number().int().positive().max(2_147_483_647)
export const pimDeliverySettlementSelectionSchema = z
  .object({ deliveryId: pimDeliverySettlementIdSchema })
  .strict()
export const pimDeliverySettlementExecuteSchema = pimDeliverySettlementSelectionSchema
  .extend({ evidenceHash: z.string().regex(/^[a-f0-9]{64}$/) })
  .strict()
export type PimDeliverySettlementSelection = z.infer<typeof pimDeliverySettlementSelectionSchema>
export type PimDeliverySettlementExecute = z.infer<typeof pimDeliverySettlementExecuteSchema>
